var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[_c('clip-loader',{attrs:{"loading":_vm.isLoading,"size":_vm.size}}),_c('p',{staticClass:"text-center"},[_vm._v("Please wait...")])],1):_c('div',[(!_vm.subscription)?_c('PriceSelection',{attrs:{"productType":_vm.productType}}):_c('SubscribedAccount',{attrs:{"subscription":_vm.subscription}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }